var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdminNextIframe',{key:_vm.$route.params.collectionID,attrs:{"path":`/collections/${_vm.$route.params.collectionID}`,"query":{ clientId: _vm.$route.params.id },"allow":"clipboard-write"},on:{"navigate":_vm.onNavigate,"back":_vm.onBack}})
}
var staticRenderFns = []

export { render, staticRenderFns }